import EnquiryForm from "@/components/EnquiryForm";
import { COMPANY } from "@/lib/siteData";
import { Mail, Phone, MapPin, Clock, Instagram, Linkedin } from "lucide-react";

const ContactPage = () => {
  return (
    <div data-testid="contact-page">
      <section className="bg-ivory">
        <div className="max-w-7xl mx-auto px-5 md:px-10 py-20 md:py-28 grid grid-cols-1 lg:grid-cols-12 gap-14">
          <div className="lg:col-span-5 reveal">
            <div className="overline mb-5">Contact</div>
            <h1 className="font-display text-5xl md:text-6xl leading-[1.02] tracking-tight font-light">
              Let's build<br />
              <span className="italic text-navy">something real.</span>
            </h1>
            <p className="mt-6 text-base md:text-lg text-black/70 leading-relaxed">
              Architects, designers, dealers and franchisee prospects — reach us directly. We respond to every serious enquiry within one working day.
            </p>

            <div className="mt-12 space-y-6">
              <div className="flex gap-4 items-start">
                <div className="w-10 h-10 shrink-0 flex items-center justify-center border border-brandgray text-teal">
                  <MapPin size={18} />
                </div>
                <div>
                  <div className="overline">Head Office</div>
                  <div className="mt-1 text-base text-black leading-relaxed">{COMPANY.address}</div>
                </div>
              </div>
              <div className="flex gap-4 items-start">
                <div className="w-10 h-10 shrink-0 flex items-center justify-center border border-brandgray text-teal">
                  <Phone size={18} />
                </div>
                <div>
                  <div className="overline">Call us</div>
                  <a href={`tel:${COMPANY.phone.replace(/\s/g, "")}`} className="mt-1 block text-base text-black hover:text-navy">{COMPANY.phone}</a>
                </div>
              </div>
              <div className="flex gap-4 items-start">
                <div className="w-10 h-10 shrink-0 flex items-center justify-center border border-brandgray text-teal">
                  <Mail size={18} />
                </div>
                <div>
                  <div className="overline">Email</div>
                  <a href={`mailto:${COMPANY.email}`} className="mt-1 block text-base text-black hover:text-navy">{COMPANY.email}</a>
                </div>
              </div>
              <div className="flex gap-4 items-start">
                <div className="w-10 h-10 shrink-0 flex items-center justify-center border border-brandgray text-teal">
                  <Clock size={18} />
                </div>
                <div>
                  <div className="overline">Hours</div>
                  <div className="mt-1 text-base text-black">Mon – Sat · 10:00 AM – 6:00 PM IST</div>
                </div>
              </div>
              <div className="flex gap-4 items-start">
                <div className="w-10 h-10 shrink-0 flex items-center justify-center border border-brandgray text-teal">
                  <Instagram size={18} />
                </div>
                <div>
                  <div className="overline">Follow</div>
                  <div className="mt-1 flex gap-4 text-base">
                    <a
                      href="https://www.instagram.com/tarushfurniture/"
                      target="_blank"
                      rel="noopener noreferrer"
                      data-testid="contact-social-instagram"
                      className="text-black hover:text-navy underline-offset-4 hover:underline"
                    >
                      @tarushfurniture
                    </a>
                    <span className="text-black/30">·</span>
                    <a
                      href="https://www.linkedin.com/company/tarush/"
                      target="_blank"
                      rel="noopener noreferrer"
                      data-testid="contact-social-linkedin"
                      className="text-black hover:text-navy underline-offset-4 hover:underline inline-flex items-center gap-1.5"
                    >
                      <Linkedin size={14} /> LinkedIn
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="lg:col-span-7 reveal">
            <EnquiryForm variant="contact" title="Send us an enquiry" subtitle="A brief message about your project or requirement is all we need to get started." />
          </div>
        </div>
      </section>
    </div>
  );
};

export default ContactPage;
